// TrashIcon.tsx
import React from 'react'

const SearchIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="search">
            <g id="Vector">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
                    fill="#3F3F3F"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.8536 13.8536C13.6583 14.0488 13.3417 14.0488 13.1464 13.8536L9.29289 10.2071L10 9.5L13.8536 13.1464C14.0488 13.3417 14.0488 13.6583 13.8536 13.8536Z"
                    fill="#3F3F3F"
                />
            </g>
        </g>
    </svg>
)

export default SearchIcon
